module.exports = __webpack_public_path__ + "static/media/gcdef_10035.04cf4d63.ico";